import { useCallback, useMemo } from 'react';
import { DelimitedArrayParam, useQueryParams } from 'use-query-params';

const QUERY_PARAMS_CONFIG = {
  merge: DelimitedArrayParam,
};

const useMergedPlotIds = (): {
  mergedPlotIds: string[];
  setMergedPlotIds: (ids: string[] | null) => void;
} => {
  const [{ merge }, setQuery] = useQueryParams(QUERY_PARAMS_CONFIG);

  const mergedPlotIds = useMemo(() => {
    const plotIds = merge?.filter(Boolean) ?? [];

    return plotIds as string[];
  }, [merge]);

  const setMergedPlotIds = useCallback(
    (plotIds: string[] | null) => {
      const filteredIds = plotIds?.filter(Boolean) ?? [];

      setQuery({
        merge: filteredIds.length ? filteredIds : undefined,
      });
    },
    [setQuery],
  );

  return {
    mergedPlotIds,
    setMergedPlotIds,
  };
};

export default useMergedPlotIds;
